export const forbidden = '/forbidden';
export const login = '/login';
export const resetPassword = '/reset-password';
